module.exports = __webpack_public_path__ + "img/ic_badge_plus.373493cf.svg";